export default {
    namespaced: true,

    state: {
        stateAids: false,
    },

    getters: {
        getStateAids: state => state.stateAids,
    },

    mutations: {
        SET_AIDS(state, item) {
            state.stateAids = item
        },
        REMOVE_AIDS(state) {
            state.stateAids = false
        },
    },

    actions: {
        setAids({ commit }, item) {
            commit('SET_AIDS', item)
        },
        removeAids({ commit }) {
            commit('REMOVE_AIDS')
        },
    },
}
